import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import styled from 'styled-components';

const Container = styled.div`
  grid-area: itemName;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  font-size: min(1.5vw, 2.5em);
  font-weight: bold;
  background-color: #e7e7e7;
`;

const ItemName = () => {
  const {
    BidStore: { auctionProduct },
  } = useStores();

  return <Container>{auctionProduct?.product}</Container>;
};

export default observer(ItemName);
